export default "__VITE_ASSET__CbiNjfSW__"